export default {
  listItemSelected: state => state.listItemSelected
}
